import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import styled from "styled-components";

type PieChartParam = {
  title: string;
  values: { name: string; value: number }[];
  unit?: string;
  width: number;
  height: number;
};

const backgroundColors = [
  "#4f46e5",
  "#0ea5e9",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#f43f5e",
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  name,
}: {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
  index: number;
  name: string;
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return percent > 0 ? (
    <text
      x={x}
      y={y}
      fill="#fff"
      textAnchor="middle" //{x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${name}-${(percent * 100).toFixed(0)}%`}
    </text>
  ) : (
    ""
  );
};

function MyPieChart(props: PieChartParam) {
  return (
    <Container>
      <Title>{props.title}</Title>
      <ResponsiveContainer width={props.width} height={props.height}>
        <PieChart width={40} height={40}>
          <Pie
            data={props.values}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={Math.min(props.width, props.height) / 2 - 10}
            fill="#8884d8"
            dataKey="value"
            nameKey="name"
            animationDuration={500}
          >
            {props.values.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={backgroundColors[index % backgroundColors.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-size: 0.92rem;
  font-weight: 600;
  text-align: center;
`;

export default MyPieChart;
